<h4 *ngIf="edit">Edit: Selected Privilege: {{boundPrivilege?.name}} {{roleHasPrivilegeValue}}</h4>
<h4 *ngIf="!edit">Create: <span *ngIf="selectedPrivilegeId">Selected Privilege: {{boundPrivilege?.name}}</span></h4>
<mat-horizontal-stepper #hStepper [linear]="true">
  <mat-step [stepControl]="firstFormGroup">
    <ng-template matStepLabel>Select Privilege</ng-template>
    <data-table (custom)="selectPrivilege($event)" [columns]="[{prop: 'name'}]" [dataProvider]="privilegeService" icon="done">
    </data-table>
    <form [formGroup]="firstFormGroup">
      <input [(ngModel)]="selectedPrivilegeId" formControlName="privilegeId" required type="hidden">
    </form>
  </mat-step>

  <mat-step *ngIf="edit" [stepControl]="secondFormGroupEdit">
    <ng-template matStepLabel>Edit value</ng-template>
    <form [formGroup]="secondFormGroupEdit">
      <mat-form-field class="full-width">
        <input [(ngModel)]="roleHasPrivilegeValue" formControlName="roleHasPrivilegeValue" matInput placeholder="value" required>
      </mat-form-field>
    </form>
  </mat-step>

  <mat-step *ngIf="!edit">
    <ng-template matStepLabel>Set values</ng-template>
    <ng-container *ngFor="let value of values;let i = index; trackBy:trackByFn">
      <mat-form-field class="full-width">
        <input [(ngModel)]="values[i]" matInput placeholder="value">
      </mat-form-field>
    </ng-container>
    <button (click)="addValue()" class="ibexfusion-icon-button" mat-icon-button>
      <mat-icon>add</mat-icon>
    </button>
  </mat-step>

  <mat-step *ngIf="!edit">
    <ng-template matStepLabel>Done</ng-template>
    <p>
      Add Privilege: {{boundPrivilege?.name}} - {{values | json}}
    </p>
    <div>
      <button (click)="abort()" color="accent" mat-raised-button>Abort</button>
      <button (click)="save()" color="primary" mat-raised-button>Add</button>
    </div>
  </mat-step>

  <mat-step *ngIf="edit">
    <ng-template matStepLabel>Done</ng-template>
    <p>
      Update Privilege: {{boundPrivilege?.name}} - {{roleHasPrivilegeValue}}
    </p>
    <div>
      <button (click)="abort()" color="accent" mat-raised-button>Abort</button>
      <button (click)="update()" color="primary" mat-raised-button>Update</button>
    </div>
  </mat-step>

</mat-horizontal-stepper>
